import { createContext } from 'react';

const CateringContext = createContext();
CateringContext.displayName = 'CateringContext';

export default CateringContext;
